import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axios from "../../utils/axiosinstance";
import { useAuthStore } from "../../../../user/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import { OrderFileProps } from "./useGetOrderInfo";

export interface OrderPutRequest {
    order_name: string;
    order_mobile: string;
    product_idx: number;
    wreath_sender: string;
    wreath_word: string;
    recipient_name: string;
    recipient_mobile: string;
    is_union: boolean;
    event_content_idx: number;
    related_person: string;
    work_location: string;
    department: string;
    company_tel: string | null;
    delivery_immediate: boolean;
    delivery_date: string;
    delivery_time: string;
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail?: string;
    delivery_memo_idx: number | null;
    delivery_memo: string;
    file_memo: string;
    order_memo: string;
    del_file_idx: number[];
    order_file: File[] | OrderFileProps[];
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutOrderInfo = (
    // successCallback?: () => void,
    order_idx: number,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, OrderPutRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const url = enum_api_uri.user.put_order_info.replace(":order_idx", order_idx.toString());

    return useMutation<null, AxiosError<ApiErrorResponse>, OrderPutRequest>({
        mutationFn: async (data: OrderPutRequest) => {
            try {
                // FormData 생성
                const formData = new FormData();

                // 모든 키-값을 FormData에 추가
                Object.entries(data).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        if (Array.isArray(value)) {
                            value.forEach(item => {
                                if (item instanceof File) {
                                    formData.append(key, item); // 파일 추가
                                } else {
                                    formData.append(key, JSON.stringify(item)); // 배열 요소 문자열 변환
                                }
                            });
                        } else {
                            formData.append(key, value as string | Blob);
                        }
                    }
                });

                const response = await axios.put(url, formData, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                });

                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            // queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
            // successCallback?.();
        },
    });
};
